import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { z } from 'zod'

import { authenticatedRoute } from '@/app/routes/authenticated'
import { pageSearch as page, textSearch as text } from '@/shared/api/search'
import { requirePermission } from '@/shared/auth/guards'

const listSearch = z.object({ page, search: text, status: text, type: text, locale: text })

export const newsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/news',
  beforeLoad: requirePermission('news.view'),
})

export const newsListRoute = createRoute({
  getParentRoute: () => newsRoute,
  path: '/',
  validateSearch: (search) => listSearch.parse(search),
  component: lazyRouteComponent(() => import('./pages/news-page'), 'NewsPage'),
})

export const newsCreateRoute = createRoute({
  getParentRoute: () => newsRoute,
  path: 'new',
  beforeLoad: requirePermission('news.manage'),
  component: lazyRouteComponent(() => import('./pages/news-form-page'), 'NewsFormPage'),
})

export const newsEditRoute = createRoute({
  getParentRoute: () => newsRoute,
  path: '$newsId',
  component: lazyRouteComponent(() => import('./pages/news-form-page'), 'NewsFormPage'),
})

export const newsRoutes = newsRoute.addChildren([newsListRoute, newsCreateRoute, newsEditRoute])
